import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MeatballMenuService } from './meatball-menu.service';
import {ProductServiceResponse, RequestRequiredData} from './meatball-menu.model';

@Directive({
  selector: '[appMeatBallMenu]',
  exportAs: 'meatBallMenu',
})
export class MeatBallMenuDirective {
  @Input()
  public meatBallMenuTitle: string;
  @Input()
  public requestRequiredData: RequestRequiredData;
  @Input()
  public productServicesList: ProductServiceResponse;
  @Input()
  public otherLinks: [];
  @Input()
  public hasBOCockpit: boolean;
  @Input()
  public hasMijnWonen: boolean;
  @Input()
  public hasGeldOver: boolean;

  constructor(
    public readonly elementRef: ElementRef,
    private readonly meatBallMenuService: MeatballMenuService,
  ) { }

  @HostListener('click', ['$event.target'])
  public show(): void {
    this.meatBallMenuService.addInfoToMeatBallMenu(this.elementRef, {
      title: this.meatBallMenuTitle,
      productServiceList: this.productServicesList || null,
      requestRequiredData: this.requestRequiredData || null,
      otherLinks: this.otherLinks || null,
      hasBOCockpit: this.hasBOCockpit || false,
      hasMijnWonen: this.hasMijnWonen || false,
      hasGeldOver: this.hasGeldOver || false
    });
  }

  @HostListener('document:click', ['$event.target'])
  public hideMeatBallMenuClickOff(e: any): void {
    if (e.className === 'prod-serv-icon hydrated') {
      return;
    }

    this.hideMeatBallMenu();
  }

  @HostListener('document:scroll', ['$event.target'])
  private hideMeatBallMenuOnScroll(): void {
    this.hideMeatBallMenu();
  }

  private hideMeatBallMenu(): void {
    this.meatBallMenuService.hideOverlay();
  }
}
